export enum ReminderChannel {
  CREATE = 'reminder::create',
  EDIT = 'reminder::patch',
  DELETE = 'reminder::delete',
}
